import {Component, EventEmitter, Output} from '@angular/core';
import {LanguageEnum} from '../../../../../../../core/enums/language.enum';

@Component({
    selector: 'app-wizard-language-option',
    templateUrl: './wizard-language-option.component.html',
    styleUrls: ['./wizard-language-option.component.scss']
})
export class WizardLanguageOptionComponent {
    englishGB = LanguageEnum.ENGLISH_GB;
    german = LanguageEnum.GERMAN;
    @Output() nextStepEvent: EventEmitter<LanguageEnum> = new EventEmitter();

    nextStepClick(language: LanguageEnum): void {
        this.nextStepEvent.emit(language);
    }
}
